import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppointmentStore } from './appointment.store';
import { Appointment, appointmentFactory } from './appointment.model';
import { Observable } from 'rxjs';
import { LanguageService } from '../../../core/services/language/language.service';
import { SettingsQuery } from '../settings/settings.query';
import { CompanyQuery } from '../company/company.query';
import { UserQuery } from '../user/user.query';
import { ClinicDetailQuery } from '../clinic-detail/clinic-detail.query';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class AppointmentService {
    constructor(
        private appointmentStore: AppointmentStore,
        private http: HttpClient,
        private languageService: LanguageService,
        private settingsQuery: SettingsQuery,
        private companyQuery: CompanyQuery,
        private userQuery: UserQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private apiService: ApiService
    ) {}

    /*---------------------*/
    /** OPERACIONES ENTITY */
    /*---------------------*/

    add(appointment: Appointment) {
        this.appointmentStore.add(appointment);
    }

    update(id, appointment: Partial<Appointment>) {
        this.appointmentStore.update(id, appointment);
    }

    remove(id: ID) {
        this.appointmentStore.remove(id);
    }

    setAppointments(appointments) {
        this.appointmentStore.set(appointments);
    }

    /*---------------*/
    /** LLAMADAS API */
    /*---------------*/

    /**
     * Llamada api para obtener las citas de un usuario para una clínica
     */
    private getAppointmentsUserApi(
        systemKey: string,
        clientToken: string,
        clinicId: string
    ): Observable<any> {
        let params = new HttpParams();
        params = params.append('SystemKey', systemKey);
        params = params.append('ClientToken', clientToken);
        params = params.append('ClinicID', clinicId);
        params = params.append('Services', null);
        params = params.append('ProfessionalID', null);
        params = params.append('ProfessionalName', null);
        params = params.append('DiaryDate', null);
        params = params.append('TimeEnd', null);
        params = params.append('TimeStart', null);
        params = params.append('CabineID', null);
        params = params.append('Cmd', 'c1024');
        params = params.append('Locale', this.languageService.getLocale());

        return this.apiService.callApi(params);
    }

    /**
     * Llamada api para borrar una cita de un usuario
     */
    private deleteAppointmentApi(
        systemKey: string,
        clientToken: string,
        appointmentId: string
    ): Observable<any> {
        let params = new HttpParams();
        params = params.append('SystemKey', systemKey);
        params = params.append('ClientToken', clientToken);
        params = params.append('AppID', appointmentId);
        params = params.append('Cmd', 'c1044');
        params = params.append('Locale', this.languageService.getLocale());

        return this.apiService.callApi(params);
    }

    /*------------*/
    /** SERVICIOS */
    /*------------*/

    /**
     * Llama a la API para obtener las citas del usuario que hay logeado en el sistema para la clínica en la que está
     * Después ingresa las citas en Akita
     */
    async getAppointments() {
        const appointmentsData = await this.getAppointmentsUserApi(
            this.settingsQuery.systemKeyURL,
            this.userQuery.tokenId,
            this.clinicDetailQuery.id
        ).toPromise();

        /**
         * Cargamos las clínicas a la Store
         */
        this.setAppointmentsByApi(appointmentsData.Apps);
    }

    /**
     * Llama a la API para borrar una cita de un usuario en una clínica
     */
    async deleteAppointment(appointmentId: string) {
        const appointmentsData = await this.deleteAppointmentApi(
            this.settingsQuery.systemKeyURL,
            this.userQuery.tokenId,
            appointmentId
        ).toPromise();

        /**
         * Volvemos a cargar las clínicas al borrar una
         */
        this.getAppointments();
    }

    /**
     * Crea las citas a partir de una Array y las carga en el Store
     */
    setAppointmentsByApi(appointments) {
        const appointmentsEntities = [];
        appointments.forEach((appointment) => {
            appointmentsEntities.push(appointmentFactory(appointment));
        });

        this.setAppointments(appointmentsEntities);
    }
}
